import { ajax } from 'rxjs/ajax';
import { map, timeout, catchError, finalize } from 'rxjs/operators';
import { of } from 'rxjs';
import store from '../app/store';
import responseConverter from './apiResponseConverter';
import { startAPI, endAPI, resetSessionTimeout } from '../redux/appAction';
import { resetNotify } from '../redux/notifyAction';
import apiConfig from './apiConfig';
import { isDspCustomerApi } from '../common/auth/dsp';

export const callDspAmToken = (svgConfig) => {
	const header = {
		'Accept-API-Version': 'protocol=1.0,resource=2.1',
		'X-Client-Id': svgConfig.CMB_DSP_TOKEN_API_CLIENT_ID,
		'X-Client-Secret': svgConfig.CMB_DSP_TOKEN_API_CLIENT_SECRET,
		'X-Requested-With': 'XMLHttpRequest',
		'Content-Type': 'application/json'
	};
	const url = svgConfig.CMB_DSP_TOKEN_API_URL;
	const wAjax = ajax({
		url: url,
		method: 'POST',
		headers: header,
		withCredentials: true,
		crossDomain: true,
		dataType: 'json'
	});
	return wAjax.pipe(timeout(svgConfig.timeout));
};

const constructQueryString = (request) => {
	if (request) {
		const qstr = [];
		for (const k in request) {
			qstr.push(String(k) + '=' + encodeURIComponent(JSON.stringify(request[k])));
		}
		const qr = qstr.join('&');
		console.debug(qr);
		return '?' + request;
	} else {
		return '';
	}
};

const parseUrlParam = (url, urlParam) => {
	let parsedUrl = url;
	if (urlParam) {
		for (const key in urlParam) {
			const rpKey = '{' + key + '}';
			const repEx = new RegExp(rpKey, 'g');
			parsedUrl = parsedUrl.replace(repEx, urlParam[key]);
		}
	}
	return parsedUrl;
};

const constructHeaders = (store, msgId, urlParam) => {
	const { session } = store.getState();
	console.log('session is ', session);
	// @@WP-REACT: You may publish the header value from state.session or any data in state
	// ...
	let header = {
		'Content-Type': 'application/json',
		'x-hsbc-channel-id': 'OHI',
		'x-hsbc-chnl-countryCode': 'HK',
		'x-hsbc-chnl-group-member': 'HBAP',
		'x-hsbc-lob': session.bizLine || 'PFS',
		'x-hsbc-locale': session.locale.replace('-', '_'),
		'Token_type': 'SESSION_TOKEN',
		'x-hsbc-gbgf': 'CDM'
		//'AMToken': 'rZXDqAMs24EkuxtRolyePNdcZlk.*AAJTSQACMDIAAlNLABxBaDE4c2FnN21kSTJkWGhlQTAzNmZvZS9WSGM9AAR0eXBlAANDVFMAAlMxAAA.*'
	};
	if (msgId === 'fetchQuestionnairesResult_wealth' || msgId === 'responses_wealth') {
	//header['X-WEALTH-CUSTOMER-NUMBER'] = session.custID;
	//header['X-HSBC-EMPLOYEE-ID'] = '29000101';
	//header['X-HSBC-CUSTOMER-NUMBER'] = 'IA760970';
	}

	if (msgId === 'retrieveCustomerInfoByCustomerId') {
		header['X-HSBC-Wealth-Customer-Number'] = urlParam.customerId;
	}

	return header;
};

const apiCall = (msgId, svcConfig, request, urlParam) => {
	store.dispatch(resetNotify());
	store.dispatch(startAPI());
	store.dispatch(resetSessionTimeout());
	let apiUrl = svcConfig.svcHost + svcConfig[msgId].url;
	if (msgId === 'retrieveCustomerInfoByCustomerId') {
		apiUrl = svcConfig[msgId].url;
	}
	const apiMethod = svcConfig[msgId].method;
	apiUrl = parseUrlParam(apiUrl, urlParam);
	let wAjax = null;

	const reqHeader = constructHeaders(store, msgId, urlParam);
	const credentials = isDspCustomerApi(apiUrl) ? { withCredentials: true, crossDomain: true } : {};
	console.log('before apiUrl', apiUrl);
	if (apiUrl.endsWith('.json')) {
		apiUrl = process.env.PUBLIC_URL + '/mock';
		const dummyUrlArr = svcConfig[msgId].url.split(':');
		let statusCode = 200;
		if (dummyUrlArr.length === 2) {
			statusCode = dummyUrlArr[0];
			apiUrl += dummyUrlArr[1];
		} else {
			apiUrl += svcConfig[msgId].url;
		}
		wAjax = ajax({
			url: apiUrl,
			method: 'GET',
			headers: { ...reqHeader, 'rxjs-hdr-status': statusCode }
		});
	} else if (svcConfig[msgId].method === 'GET') {
		if (msgId === 'retrieveReportDocumnetId') {
			wAjax = ajax({
				...credentials,
				url: apiUrl,
				method: apiMethod,
				headers: reqHeader
			});
		}
		else if (msgId === 'downloadEsgReport') {
			const requestKey = svcConfig[msgId].requestKey;
			console.log('requestKey=', requestKey);
			//url = url + '?' + requestKey + '=' + encodeURIComponent(requestBody);
			wAjax = ajax({
				...credentials,
				url: apiUrl + '?' + requestKey + '=' + encodeURIComponent(request) + '&source=r',
				method: apiMethod,
				headers: reqHeader
			});
		}
		else if (msgId === 'downloadLccReport') {
			const requestKey = svcConfig[msgId].requestKey;
			console.log('requestKey=', requestKey);
			//url = url + '?' + requestKey + '=' + encodeURIComponent(requestBody);
			wAjax = ajax({
				...credentials,
				url: apiUrl + '?' + requestKey + '=' + encodeURIComponent(request),
				method: apiMethod,
				headers: reqHeader
			});
		} else {
			const qs = constructQueryString(request);
			wAjax = ajax({
				...credentials,
				url: apiUrl + qs,
				method: apiMethod,
				headers: reqHeader
			});
		}

	} else if (svcConfig[msgId].method === 'POST' || svcConfig[msgId].method === 'PUT') {
		wAjax = ajax({
			...credentials,
			url: apiUrl,
			method: apiMethod,
			headers: reqHeader,
			responseType: (apiConfig.apiListWithTextResponse.includes(msgId) ? 'text' : 'json'),
			body: JSON.stringify(request)
		});
	} else if (svcConfig[msgId].method === 'DELETE') {
		// TODO: implement DELETE method for ajax
		console.warn('++++Test: apiService DELETE is not implemented.');
	}
	// @@WP-REACT: supplement more request method like  DELETE, PATCH etc if need
	// ...

	const apiTimeout = svcConfig[msgId].timeout ? svcConfig[msgId].timeout : apiConfig.timeout;

	return wAjax.pipe(timeout(apiTimeout));
};

const apiService = (msgId, svcConfig, request, urlParam) => apiCall(msgId, svcConfig, request, urlParam).pipe(
	finalize(
		() => {
			store.dispatch(endAPI());
		}
	)
).pipe(
	map(
		rxResponse => {
			const wResponse = responseConverter(rxResponse, msgId);
			return wResponse;
		}
	),
	catchError(rxError => {
		const error = responseConverter(rxError, msgId);
		return of(error);
	})
);

export default apiService;
